import React from "react";

import Header from "./Components/Header";
import Footer from "./Components/Footer";

const BlogDetail = () => {
    return(
        <div>
        <Header/>
        <main id="main">
            <section id="breadcrumbs" class="breadcrumbs">
                <div class="container">
                    <div class="d-flex justify-content-between align-items-center">
                        <h2>Portfolio Detail</h2>
                        <ol>
                            <li><a href="/index">Home</a></li>
                            <li><a href="/portfolio">Portfolio</a></li>
                            <li>Portfolio Detail</li>
                        </ol>
                    </div>
                </div>
            </section>    
            <section id="blog" class="blog">
                <div class="container" data-aos="fade-up">
                    <div class="row">
                        <div class="col-lg-8 entries">
                            <article class="entry entry-single">
                                <div class="entry-img">
                                    <img src="assets/images/blog/blog-1.jpg" alt="" class="img-fluid"/>
                                </div>
                                <h2 class="entry-title">
                                    <a href="/blog-detail">Dolorum optio tempore voluptas dignissimos cumque fuga qui quibusdam quia</a>
                                </h2>
                                <div class="entry-meta">
                                    <ul>
                                        <li class="d-flex align-items-center"><i class="bi bi-person"></i> <a href="/blog-detail">John Doe</a></li>
                                        <li class="d-flex align-items-center"><i class="bi bi-clock"></i> <a href="/blog-detail"><time datetime="2020-01-01">Jan 1, 2020</time></a></li>
                                        <li class="d-flex align-items-center"><i class="bi bi-chat-dots"></i> <a href="/blog-detail">12 Comments</a></li>
                                    </ul>
                                </div>
                                <div class="entry-content">
                                    <p>
                                    Similique neque nam consequuntur ad non maxime aliquam quas. Quibusdam animi praesentium. Aliquam et laboriosam eius aut nostrum quidem aliquid dicta.
                                    Et eveniet enim. Qui velit est ea dolorem doloremque deleniti aperiam unde soluta. Est cum et quod quos aut ut et sit sunt. Voluptate porro consequatur assumenda perferendis dolore.
                                    </p>
                                    <p>
                                    Sit repellat hic cupiditate hic ut nemo. Quis nihil sunt non reiciendis. Sequi in accusamus harum vel aspernatur. Excepturi numquam nihil cumque odio. Et voluptate cupiditate.
                                    </p>
                                    <blockquote>
                                    <p>
                                        Et vero doloremque tempore voluptatem ratione vel aut. Deleniti sunt animi aut. Aut eos aliquam doloribus minus autem quos.
                                    </p>
                                    </blockquote>
                                    <p>
                                    Sed quo laboriosam qui architecto. Occaecati repellendus omnis dicta inventore tempore provident voluptas mollitia aliquid. Id repellendus quia. Asperiores nihil magni dicta est suscipit perspiciatis. Voluptate ex rerum assumenda dolores nihil quaerat.
                                    Dolor porro tempora et quibusdam voluptas. Beatae aut at ad qui tempore corrupti velit quisquam rerum. Omnis dolorum exercitationem harum qui qui blanditiis neque.
                                    Iusto autem itaque. Repudiandae hic quae aspernatur ea neque qui. Architecto voluptatem magni. Vel magnam quod et tempora deleniti error rerum nihil tempora.
                                    </p>
                                    <h3>Et quae iure vel ut odit alias.</h3>
                                    <p>
                                    Officiis animi maxime nulla quo et harum eum quis a. Sit hic in qui quos fugit ut rerum atque. Optio provident dolores atque voluptatem rem excepturi molestiae qui. Voluptatem laborum omnis ullam quibusdam perspiciatis nulla nostrum. Voluptatum est libero eum nesciunt aliquid qui.
                                    Quia et suscipit non sequi. Maxime sed odit. Beatae nesciunt nesciunt accusamus quia aut ratione aspernatur dolor. Sint harum eveniet dicta exercitationem minima. Exercitationem omnis asperiores natus aperiam dolor consequatur id ex sed. Quibusdam rerum dolores sint consequatur quidem ea.
                                    Beatae minima sunt libero soluta sapiente in rem assumenda. Et qui odit voluptatem. Cum quibusdam voluptatem voluptatem accusamus mollitia aut atque aut.
                                    </p>
                                    <img src="assets/images/blog/blog-inside-post.jpg" class="img-fluid" alt=""/>
                                    <h3>Ut repellat blanditiis est dolore sunt dolorum quae.</h3>
                                    <p>
                                    Rerum ea est assumenda pariatur quasi et quam. Facilis nam porro amet nostrum. In assumenda quia quae a id praesentium. Quos deleniti libero sed occaecati aut porro autem. Consectetur sed excepturi sint non placeat quia repellat incidunt labore. Autem facilis hic dolorum dolores vel.
                                    Consectetur quasi id et optio praesentium aut asperiores eaque aut. Explicabo omnis quibusdam esse. Ex libero illum iusto totam et ut aut blanditiis. Veritatis numquam ut illum ut a quam vitae.
                                    </p>
                                    <p>
                                    Alias quia non aliquid. Eos et ea velit. Voluptatem maxime enim omnis ipsa voluptas incidunt. Nulla sit eaque mollitia nisi asperiores est veniam.
                                    </p>
                                </div>
                                <div class="entry-footer">
                                    <i class="bi bi-folder"></i>
                                    <ul class="cats">
                                        <li><a href="/">Business</a></li>
                                    </ul>
                                    <i class="bi bi-tags"></i>
                                    <ul class="tags">
                                        <li><a href="/">Creative</a></li>
                                        <li><a href="/">Tips</a></li>
                                        <li><a href="/">Marketing</a></li>
                                    </ul>
                                </div>
                            </article>
                            <div class="blog-author d-flex align-items-center">
                                <img src="assets/images/blog/blog-author.jpg" class="rounded-circle float-left" alt=""/>
                                <div>
                                    <h4>Jane Smith</h4>
                                    <div class="social-links">
                                        <a href="https://twitters.com/#"><i class="bi bi-twitter"></i></a>
                                        <a href="https://facebook.com/#"><i class="bi bi-facebook"></i></a>
                                        <a href="https://instagram.com/#"><i class="biu bi-instagram"></i></a>
                                    </div>
                                    <p>
                                    Itaque quidem optio quia voluptatibus dolorem dolor. Modi eum sed possimus accusantium. Quas repellat voluptatem officia numquam sint aspernatur voluptas. Esse et accusantium ut unde voluptas.
                                    </p>
                                </div>
                            </div>
                            <div class="blog-comments">
                                <h4 class="comments-count">8 Comments</h4>
                                <div id="comment-1" class="comment">
                                    <div class="d-flex">
                                        <div class="comment-img"><img src="assets/images/blog/comments-1.jpg" alt=""/></div>
                                        <div>
                                            <h5><a href="/">Georgia Reader</a> <a href="/" class="reply"><i class="bi bi-reply-fill"></i> Reply</a></h5>
                                            <time datetime="2020-01-01">01 Jan, 2020</time>
                                            <p>
                                            Et rerum totam nisi. Molestiae vel quam dolorum vel voluptatem et et. Est ad aut sapiente quis molestiae est qui cum soluta.
                                            Vero aut rerum vel. Rerum quos laboriosam placeat ex qui. Sint qui facilis et.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div id="comment-2" class="comment">
                                    <div class="d-flex">
                                        <div class="comment-img"><img src="assets/images/blog/comments-2.jpg" alt=""/></div>
                                        <div>
                                            <h5><a href="/">Aron Alvarado</a> <a href="/" class="reply"><i class="bi bi-reply-fill"></i> Reply</a></h5>
                                            <time datetime="2020-01-01">01 Jan, 2020</time>
                                            <p>
                                            Ipsam tempora sequi voluptatem quis sapiente non. Autem itaque eveniet saepe. Officiis illo ut beatae.
                                            </p>
                                        </div>
                                    </div>
                                    <div id="comment-reply-1" class="comment comment-reply">
                                        <div class="d-flex">
                                            <div class="comment-img"><img src="assets/images/blog/comments-3.jpg" alt=""/></div>
                                            <div>
                                                <h5><a href="/">Lynda Small</a> <a href="/" class="reply"><i class="bi bi-reply-fill"></i> Reply</a></h5>
                                                <time datetime="2020-01-01">01 Jan, 2020</time>
                                                <p>
                                                    Enim ipsa eum fugiat fuga repellat. Commodi quo quo dicta. Est ullam aspernatur ut vitae quia mollitia id non. Qui ad quas nostrum rerum sed necessitatibus aut est. Eum officiis sed repellat maxime vero nisi natus. Amet nesciunt nesciunt qui illum omnis est et dolor recusandae.
                                                    Recusandae sit ad aut impedit et. Ipsa labore dolor impedit et natus in porro aut. Magnam qui cum. Illo similique occaecati nihil modi eligendi. Pariatur distinctio labore omnis incidunt et illum. Expedita et dignissimos distinctio laborum minima fugiat.
                                                    Libero corporis qui. Nam illo odio beatae enim ducimus. Harum reiciendis error dolorum non autem quisquam vero rerum neque.
                                                </p>
                                            </div>
                                        </div>
                                        <div id="comment-reply-2" class="comment comment-reply">
                                            <div class="d-flex">
                                                <div class="comment-img"><img src="assets/images/blog/comments-4.jpg" alt=""/></div>
                                                <div>
                                                    <h5><a href="/">Sianna Ramsay</a> <a href="/" class="reply"><i class="bi bi-reply-fill"></i> Reply</a></h5>
                                                    <time datetime="2020-01-01">01 Jan, 2020</time>
                                                    <p>
                                                    Et dignissimos impedit nulla et quo distinctio ex nemo. Omnis quia dolores cupiditate et. Ut unde qui eligendi sapiente omnis ullam. Placeat porro est commodi est officiis voluptas repellat quisquam possimus. Perferendis id consectetur necessitatibus.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="comment-3" class="comment">
                                    <div class="d-flex">
                                        <div class="comment-img"><img src="assets/images/blog/comments-5.jpg" alt=""/></div>
                                        <div>
                                            <h5><a href="/">Nolan Davidson</a> <a href="/" class="reply"><i class="bi bi-reply-fill"></i> Reply</a></h5>
                                            <time datetime="2020-01-01">01 Jan, 2020</time>
                                            <p>
                                            Distinctio nesciunt rerum reprehenderit sed. Iste omnis eius repellendus quia nihil ut accusantium tempore. Nesciunt expedita id dolor exercitationem aspernatur aut quam ut. Voluptatem est accusamus iste at.
                                            Non aut et et esse qui sit modi neque. Exercitationem et eos aspernatur. Ea est consequuntur officia beatae ea aut eos soluta. Non qui dolorum voluptatibus et optio veniam. Quam officia sit nostrum dolorem.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div id="comment-4" class="comment">
                                    <div class="d-flex">
                                        <div class="comment-img"><img src="assets/images/blog/comments-6.jpg" alt=""/></div>
                                        <div>
                                            <h5><a href="/">Kay Duggan</a> <a href="/" class="reply"><i class="bi bi-reply-fill"></i> Reply</a></h5>
                                            <time datetime="2020-01-01">01 Jan, 2020</time>
                                            <p>
                                            Dolorem atque aut. Omnis doloremque blanditiis quia eum porro quis ut velit tempore. Cumque sed quia ut maxime. Est ad aut cum. Ut exercitationem non in fugiat.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            <div class="reply-form">
                                <h4>Leave a Reply</h4>
                                <p>Your email address will not be published. Required fields are marked * </p>
                                <form action="">
                                    <div class="row">
                                        <div class="col-md-6 form-group">
                                            <input name="name" type="text" class="form-control" placeholder="Your Name*"/>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <input name="email" type="text" class="form-control" placeholder="Your Email*"/>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col form-group">
                                            <input name="website" type="text" class="form-control" placeholder="Your Website"/>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col form-group">
                                            <textarea name="comment" class="form-control" placeholder="Your Comment*"></textarea>
                                        </div>
                                    </div>
                                    <button type="submit" class="btn btn-primary">Post Comment</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="sidebar">
                            <h3 class="sidebar-title">Search</h3>
                            <div class="sidebar-item search-form">
                            <form action="">
                                <input type="text"/>
                                <button type="submit"><i class="bi bi-search"></i></button>
                            </form>
                        </div>
                        <h3 class="sidebar-title">Categories</h3>
                        <div class="sidebar-item categories">
                            <ul>
                                <li><a href="/">General <span>(25)</span></a></li>
                                <li><a href="/">Lifestyle <span>(12)</span></a></li>
                                <li><a href="/">Travel <span>(5)</span></a></li>
                                <li><a href="/">Design <span>(22)</span></a></li>
                                <li><a href="/">Creative <span>(8)</span></a></li>
                                <li><a href="/">Educaion <span>(14)</span></a></li>
                            </ul>
                        </div>
                        <h3 class="sidebar-title">Recent Posts</h3>
                        <div class="sidebar-item recent-posts">
                            <div class="post-item clearfix">
                                <img src="assets/images/blog/blog-recent-1.jpg" alt=""/>
                                <h4><a href="/blog-detail">Nihil blanditiis at in nihil autem</a></h4>
                                <time datetime="2020-01-01">Jan 1, 2020</time>
                            </div>
                            <div class="post-item clearfix">
                                <img src="assets/images/blog/blog-recent-2.jpg" alt=""/>
                                <h4><a href="/blog-detail">Quidem autem et impedit</a></h4>
                                <time datetime="2020-01-01">Jan 1, 2020</time>
                            </div>
                            <div class="post-item clearfix">
                                <img src="assets/images/blog/blog-recent-3.jpg" alt=""/>
                                <h4><a href="/blog-detail">Id quia et et ut maxime similique occaecati ut</a></h4>
                                <time datetime="2020-01-01">Jan 1, 2020</time>
                            </div>
                            <div class="post-item clearfix">
                                <img src="assets/images/blog/blog-recent-4.jpg" alt=""/>
                                <h4><a href="/blog-detail">Laborum corporis quo dara net para</a></h4>
                                <time datetime="2020-01-01">Jan 1, 2020</time>
                            </div>
                            <div class="post-item clearfix">
                                <img src="assets/images/blog/blog-recent-5.jpg" alt=""/>
                                <h4><a href="/blog-detail">Et dolores corrupti quae illo quod dolor</a></h4>
                                <time datetime="2020-01-01">Jan 1, 2020</time>
                            </div>
                        </div>
                        <h3 class="sidebar-title">Tags</h3>
                        <div class="sidebar-item tags">
                            <ul>
                                <li><a href="/">App</a></li>
                                <li><a href="/">IT</a></li>
                                <li><a href="/">Business</a></li>
                                <li><a href="/">Mac</a></li>
                                <li><a href="/">Design</a></li>
                                <li><a href="/">Office</a></li>
                                <li><a href="/">Creative</a></li>
                                <li><a href="/">Studio</a></li>
                                <li><a href="/">Smart</a></li>
                                <li><a href="/">Tips</a></li>
                                <li><a href="/">Marketing</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            </section>

        </main>
        <Footer/>
        </div>
    )
};

export default BlogDetail;